// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LiveChatSystemResponseConfig {
    // TODO: Add system response config properties.
}

export interface AlmeLiveChatSystemResponseConfig {
    liveChatSystemResponse: LiveChatSystemResponseConfig;
}

/**
 * This is the baseline live chat system response config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeLiveChatSystemResponseConfig = {
    liveChatSystemResponse: {},
};

export default defaultConfig;